import Api from "./Api";

export default {
  async loginUser(data) {
    try {
      let response = await Api({url: "/auth/user/login", data: data, method: "post"})
      return response
    }catch(err){
      throw new Error('Server not responding !');
    }
  }
}
